module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fjYZS"))).then(() => parcelRequire('5erN3'));